import { HStack, Show } from 'shared';
import { Icon, iconNames } from 'shared_DEPRECATED/components/Icon';

import { Typography } from 'shared/components/Typography';

type SessionsFormCoachingToolsCompletionIndicatorProps = {
  isCompleted: boolean;
  showLabel?: boolean;
};

export const SessionsFormCoachingToolsCompletionIndicator = ({
  isCompleted,
  showLabel = true,
}: SessionsFormCoachingToolsCompletionIndicatorProps) => (
  <HStack>
    {showLabel && (
      <Typography type="meta" fontWeight="regular" color="black">
        {isCompleted ? 'Completed' : 'In progress'}
      </Typography>
    )}
    <Show
      when={isCompleted}
      fallback={<Icon name={iconNames.pending} fill="gray" />}
    >
      <Icon name={iconNames.checkCircle} fill="green" />
    </Show>
  </HStack>
);
